/* @flow */
import Button from 'components/Button.jsx';
import CenteredContainer from 'components/CenteredContainer.jsx';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import Copy from 'components/Copy.jsx';
import Divider from 'components/Divider.jsx';
import EducationMediaObject from './EducationMediaObject.jsx';
import EventTrackingConstants from '../constants/EventTrackingConstants';
import Link from 'components/Link.jsx';
import React, { PropTypes } from 'react';
import Text from 'components/Text.jsx';

import './styles/TreasurerAddBankAccountInterstitial.scss';

type Props = {
  connectedBankAccount: ConnectedBankAccount,
  onAddBankAccount: () => void,
  eventScreenName: string,
};

export default class TreasurerAddBankAccountInterstitial extends React.Component {
  props: Props;

  static contextTypes = {
    eventContextName: PropTypes.string,
  }

  static defaultProps = {
    eventScreenName: EventTrackingConstants.TREASURER_INTERSTITIAL,
  }

  renderCopy() {
    const { connectedBankAccount } = this.props;

    return (
      <div>
        <Text element="h2" size="xlarge" className="TreasurerSignInInterstitial-title">
          A safe, simple way to collect and manage funds for your school.
        </Text>
        <EducationMediaObject
          className="TreasurerSignInInterstitial-media"
          image={require('assets/images/payments/Treasurer/signin-dollarsign.svg')}
          title="No more cash or checks"
          text={`Parents and students can send money directly to your school so teachers don’t
            need to manage funds.`}
        />
        <EducationMediaObject
          className="TreasurerSignInInterstitial-media"
          image={require('assets/images/payments/Treasurer/signin-document.svg')}
          title="Effortless deposits"
          text={`Authorize ${connectedBankAccount.getConnectedUserName()} to deposit money to your
            school's bank account—without sharing any account information.`}
        />
        <EducationMediaObject
          className="TreasurerSignInInterstitial-media"
          image={require('assets/images/payments/Treasurer/signin-lock.svg')}
          title="Safety and security"
          text={`Remind partners with bank-level payment solutions to ensure that everyone’s
            information is secure and protected.`}
        />
      </div>
    );
  }

  renderNote() {
    const { connectedBankAccount } = this.props;
    const note = connectedBankAccount && connectedBankAccount.getNote() ?
      connectedBankAccount.getNote() :
      `"I'm using Remind to organize my class activities. I'd love for you to see my event details
      and monitor all funds collected. With your approval, I can also deposit directly
      into any bank account you chose. Thanks!"`;
    return (
      <blockquote className="TreasurerSignInInterstitial-note">
        <Copy center>
          <Text element="p" lineHeight="large" size="small">
            “{note}”
          </Text>
          <cite>
            <Text weight="semibold" element="div">
              {connectedBankAccount.getConnectedUserName()}
            </Text>
            <Text italic element="div">
              {connectedBankAccount.getOrganizationName()}
            </Text>
          </cite>
        </Copy>
      </blockquote>
    );
  }

  render() {
    const continueEventName = 'continue';
    const skipEventName = 'skip';
    const { eventContextName } = this.context;

    return (
      <CenteredContainer className="TreasurerSignInInterstitial" size="small">
        {this.renderNote()}
        <div className="TreasurerSignInInterstitial-action">
          <div className="TreasurerSignInInterstitial-action-button">
            <Button
              eventScreenName={this.props.eventScreenName}
              eventElementName={continueEventName}
              eventContextName={eventContextName}
              onClick={this.props.onAddBankAccount}>
              Continue
            </Button>
          </div>
        </div>
        <Divider size="small" />
        {this.renderCopy()}
        <Divider size="small" />
        <footer className="TreasurerSignInInterstitial-action">
          <div className="TreasurerSignInInterstitial-action-button">
            <Button
              element="div"
              color="brand"
              weight="semibold"
              level="text"
              eventScreenName={this.props.eventScreenName}
              eventElementName={continueEventName}
              eventContextName={eventContextName}
              onClick={this.props.onAddBankAccount}>
              Continue
            </Button>
            <div>
              <Link
                eventScreenName={this.props.eventScreenName}
                eventElementName={skipEventName}
                eventContextName={eventContextName}
                href="/settings/transactions"
                weight="semibold">
                Skip for now
              </Link>
            </div>
          </div>
        </footer>
      </CenteredContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/TreasurerAddBankAccountInterstitial.jsx